import React from "react";
import { SolutionSection } from "@/components/design-system/SolutionSection/SolutionSection";

const leftItems = [
  "Static benefit portals employees rarely return to",
  "Generic content sent to all employees alike",
  "No insight into who is struggling financially",
  "Silent stress eroding productivity and retention",
] as const;

const rightItems = [
  "Personalized financial guidance tailored to each employee's situation",
  "24/7 AI coach for paycheck questions, 401(k), benefits and more",
  "Real-time signals on employee financial wellbeing and benefit utilisation",
  "Measurable reduction in stress-driven turnover and absenteeism",
] as const;

export const EmployerSolutionSection: React.FC = () => (
  <SolutionSection
    backgroundSrc="/bg-emp-solutions.png"
    label="The Bravo Solution"
    heading={
      <>
        Now you know the cost.{" "}
        <span className="text-primary-500">Here's the fix.</span>
      </>
    }
    description="Bravo gives every employee a personal AI financial guide — answering real questions about their benefits, paycheck, 401(k), and financial life in real time, before stress becomes a business problem."
    leftItems={leftItems}
    rightItems={rightItems}
  />
);
